(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ke-shipping-notice"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('ke-shipping-notice');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const acknowledgementKey = 'ke-shipping-notice-us-v2';
  let acknowledged = false;
  try { acknowledged = sessionStorage.getItem(acknowledgementKey) === 'yes'; } catch (_) {}
  let pending = null;
  let replaying = false;
  let previousOverflow = '';
  const accept = dialog.querySelector('[data-ke-accept]');
  const hint = dialog.querySelector('.ke-shipping-hint');
  const returnButton = dialog.querySelector('.ke-shipping-return');
  const defaultLabels = { accept: accept.textContent, hint: hint.textContent, close: returnButton.textContent };
  const gates = new Map();
  const walletSelector = 'shopify-google-pay-button, shopify-apple-pay-button';
  const positionGates = () => {
    gates.forEach(gate => {
      const base = gate.wrapper.getBoundingClientRect();
      gate.wallets.forEach((entry, wallet) => {
        const rect = wallet.getBoundingClientRect();
        entry.trigger.style.setProperty('--ke-top', (rect.top - base.top) + 'px');
        entry.trigger.style.setProperty('--ke-left', (rect.left - base.left) + 'px');
        entry.trigger.style.setProperty('--ke-width', rect.width + 'px');
        entry.trigger.style.setProperty('--ke-height', rect.height + 'px');
      });
    });
  };
  const resizeObserver = new ResizeObserver(positionGates);
  const unlockWallets = () => {
    observer.disconnect();
    resizeObserver.disconnect();
    gates.forEach((gate, host) => {
      gate.wallets.forEach((entry, wallet) => { wallet.inert = entry.wasInert; entry.trigger.remove(); });
      gate.wrapper.classList.remove('ke-wallet-notice-host');
    });
    gates.clear();
  };
  const open = (button, form, kind) => {
    if (dialog.open) return;
    pending = { button, form, kind };
    const wallet = kind === 'wallet';
    accept.textContent = wallet ? dialog.dataset.walletAccept : defaultLabels.accept;
    hint.textContent = wallet ? dialog.dataset.walletHint : defaultLabels.hint;
    returnButton.textContent = wallet ? dialog.dataset.walletClose : defaultLabels.close;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
  };
  const stop = event => { event.preventDefault(); event.stopImmediatePropagation(); };
  const scanWallets = () => {
    if (acknowledged) return;
    document.querySelectorAll('.shopify-payment-button, .additional-checkout-buttons').forEach(host => {
      const wallets = host.querySelectorAll(walletSelector);
      if (!wallets.length) return;
      let gate = gates.get(host);
      if (!gate) {
        const wrapper = host.parentElement;
        wrapper.classList.add('ke-wallet-notice-host');
        gate = { wrapper, wallets: new Map() };
        gates.set(host, gate);
        resizeObserver.observe(wrapper);
      }
      gate.wallets.forEach((entry, wallet) => {
        if (!host.contains(wallet)) { entry.trigger.remove(); resizeObserver.unobserve(wallet); gate.wallets.delete(wallet); }
      });
      wallets.forEach(wallet => {
        if (gate.wallets.has(wallet)) return;
        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'ke-wallet-notice-trigger';
        trigger.setAttribute('aria-label', dialog.dataset.walletLabel);
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', dialog.id);
        trigger.addEventListener('click', event => { stop(event); open(trigger, wallet, 'wallet'); });
        gate.wallets.set(wallet, { trigger, wasInert: wallet.inert });
        gate.wrapper.append(trigger);
        wallet.inert = true;
        resizeObserver.observe(wallet);
      });
    });
    gates.forEach((gate, host) => {
      if (!host.isConnected) {
        gate.wallets.forEach((entry, wallet) => { wallet.inert = entry.wasInert; entry.trigger.remove(); resizeObserver.unobserve(wallet); });
        resizeObserver.unobserve(gate.wrapper);
        gate.wrapper.classList.remove('ke-wallet-notice-host');
        gates.delete(host);
      }
    });
    positionGates();
  };
  const observer = new MutationObserver(scanWallets);
  if (!acknowledged) {
    scanWallets();
    observer.observe(document.body, { childList: true, subtree: true });
  }
  window.addEventListener('resize', positionGates);
  window.addEventListener('click', event => {
    if (acknowledged || replaying || !(event.target instanceof Element)) return;
    const link = event.composedPath().find(node => node instanceof Element && node.matches('.shopify-payment-button__more-options')) || event.target.closest('.shopify-payment-button__more-options');
    if (!link) return;
    stop(event);
    open(link, link.closest('form'), 'more');
  }, true);
  document.addEventListener('click', event => {
    if (acknowledged || replaying || !(event.target instanceof Element)) return;
    const button = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!button || button.disabled || !button.form) return;
    stop(event);
    open(button, button.form, 'click');
  }, true);
  document.addEventListener('submit', event => {
    if (acknowledged || replaying || !(event.target instanceof HTMLFormElement)) return;
    const button = event.submitter;
    if (!button || button.name !== 'checkout') return;
    stop(event);
    open(button, event.target, 'submit');
  }, true);
  dialog.querySelectorAll('[data-ke-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    if (pending?.button.isConnected) pending.button.focus();
    pending = null;
  });
  accept.addEventListener('click', () => {
    const action = pending;
    if (!action) return;
    acknowledged = true;
    try { sessionStorage.setItem(acknowledgementKey, 'yes'); } catch (_) {}
    pending = null;
    dialog.close();
    document.documentElement.style.overflow = previousOverflow;
    unlockWallets();
    if (action.kind === 'wallet') {
      if (action.form.isConnected) action.form.focus({ preventScroll: true });
      return;
    }
    if (!action.button.isConnected || action.button.disabled) return;
    replaying = true;
    try {
      if (action.kind === 'submit') action.form.requestSubmit(action.button);
      else action.button.click();
    } finally { replaying = false; }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
